const createFocusTrap = function () {
	const trap = {
		get active() {
			return false;
		},
		get paused() {
			return false;
		},
		activate() {
			return trap;
		},
		deactivate() {
			return trap;
		},
		pause() {
			return trap;
		},
		unpause() {
			return trap;
		},
		updateContainerElements() {
			return trap;
		}
	};

	return trap;
};

export {createFocusTrap};
